import { EuiSpacer } from '@elastic/eui';
import IOSCards from 'components/Software/iOS/InstarVision/Wizard/iOSCard';
import * as React from 'react';
export default {
  EuiSpacer,
  IOSCards,
  React
};